import {createUseStyles} from 'react-jss';

import {TEXT} from '../../common-styles/typography-style';
import {COLORS, mobileDeviceStyles} from '../../utils/style-variables';

export const useStyles = createUseStyles({
  textRight: {
    textAlign: 'right'
  },
  textCenter: {
    textAlign: 'center'
  },
  bestCurrenciesWrapper: {
    position: 'relative',
    padding: '26px 32px',
    marginBottom: 75,
    border: `1px solid ${COLORS.lightGrey30Color}`,
    borderRadius: 10,
    [mobileDeviceStyles]: {
      border: 'none',
      padding: '25px 0 0',
      marginBottom: 60
    }
  },
  header: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 18,
    minHeight: 38,
    [mobileDeviceStyles]: {
      marginBottom: 12,
      minHeight: 'auto'
    }
  },
  table: {
    position: 'relative',
    width: '100%',
    borderCollapse: 'collapse',
    ...TEXT.defaultSize,
    minHeight: 219,
    [mobileDeviceStyles]: {
      minHeight: 203
    }
  },
  row: {
    borderTop: `1px solid ${COLORS.lightGrey30Color}`,
    borderBottom: `1px solid ${COLORS.lightGrey30Color}`,
    textAlign: 'right',
    [mobileDeviceStyles]: {
      borderTop: 'none'
    }
  },
  tableHeader: {
    extend: 'row',
    backgroundColor: COLORS.backgroundGreyColor,
    color: COLORS.greyColor,
    [mobileDeviceStyles]: {
      borderTop: `1px solid ${COLORS.lightGrey30Color}`
    }
  },
  tableRow: {
    extend: 'row',
    color: COLORS.blackColor,
    '&.hidden': {
      display: 'none'
    }
  },
  tableColumn: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    padding: '10px 0 10px 0',
    width: 150,
    [mobileDeviceStyles]: {
      padding: '8px 0 8px 0',
      width: 'auto'
    },
    '&:first-child': {
      textAlign: 'left',
      width: 'auto',
      paddingLeft: 16,
      [mobileDeviceStyles]: {
        paddingLeft: 3
      }
    },
    '&:last-child': {
      paddingRight: 40,
      [mobileDeviceStyles]: {
        paddingRight: 8
      }
    }
  },
  currencyFlag: {
    display: 'inline-block',
    verticalAlign: 'middle',
    marginRight: 16,
    width: 32,
    [mobileDeviceStyles]: {
      marginRight: 4
    }
  },
  currencyInfo: {
    display: 'inline-block',
    verticalAlign: 'middle'
  },
  currencyName: {
    display: 'block',
    fontWeight: 'bold',
    color: COLORS.blackColor
  },
  currencyUnit: {
    display: 'block',
    fontWeight: 'normal',
    fontSize: 13,
    lineHeight: '18px',
    color: COLORS.greyColor
  }
});
